import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import CircleTwoToneIcon from '@mui/icons-material/CircleTwoTone';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import { StackOverflowIcon } from '../../components/icons';
import { SocialMedia } from '../../constants/links';

export default function Footer(){
    return (
        <Grid container sx={{ background:'#1D1D20', padding:4}}>
            <Grid sm={12} item sx={{ display: "flex", justifyContent: "center", alignItems: 'center', paddingBottom: 8}}>
                <CircleTwoToneIcon  color='primary' />
                <Typography 
                            component='h2' 
                            variant='h5' 
                            color='rgba(255,255,255,60%)' 
                            fontWeight='medium'
                            sx={{paddingLeft:3, }}
                >
                    Abhishek Kumar  
                </Typography>

            </Grid>

            <Grid item sm={6}>
                <Typography
                    component='h1'
                    variant='h4'
                    color='rgba(255,255,255,100%)'
                    fontWeight='medium'
                    sx={{ paddingLeft: 3, paddingBottom: 3 }}
                >
                    Lest Make something amazing together. 
                </Typography>

                <Typography
                    component='h1'
                    variant='h5'
                    color='rgba(255,255,255,100%)'
                    fontWeight='medium'
                    sx={{ paddingLeft: 3 }}
                >
                    Lets start by <Link href={SocialMedia.MAIL_TO}  color='primary'> saying hi.</Link>
                </Typography>
            </Grid>
            <Grid item sm={6}>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: 'end', flexDirection:'column', paddingRight:15}}>
                    <Link variant='body1' href="#" color='#fff' sx={{paddingBottom:2}}> Skill</Link>
                    <Link variant='body1' href="#" color='#fff' sx={{paddingBottom:2}}> Works</Link>
                    <Link variant='body1' href="#" color='#fff' sx={{paddingBottom:2}}> About</Link>
                </Box>
            </Grid>

            <Grid item sm={6} display="flex" sx={{paddingTop:'2em'}} > 
                <Typography
                    component='h1'
                    variant='h5'
                    color='rgba(255,255,255,100%)'
                    fontWeight='medium'
                    sx={{ paddingLeft: 3 }}
                >
                    Abhishek
                </Typography>
                <Typography
                    component='h1'
                    variant='h5'
                    color='rgba(255,255,255,100%)'
                    fontWeight='light'
                    sx={{ paddingLeft: 1 }}
                >
                    Kumar
                </Typography>

            </Grid>

            <Grid item sm={6} >
                <Stack direction="row" spacing={1} sx={{ justifyContent: 'end', paddingRight: 15 }}>
                    <IconButton 
                        aria-label="Linked In" size="small" sx={{color:"#fff"}} 
                        href={SocialMedia.LINKED_IN}
                        target="_blank"
                    > 
                        <LinkedInIcon />
                    </IconButton>

                    <IconButton 
                        aria-label="Github" size="small" sx={{color:"#fff"}} 
                        href={SocialMedia.GITHUB}
                        target="_blank"
                    >
                        <GitHubIcon />
                    </IconButton>

                    <IconButton 
                        aria-label="Stack Overflow" size="small" sx={{color:"#fff"}} 
                        href={SocialMedia.STACK_OVERFLOW}
                        target="_blank"
                    >
                        <StackOverflowIcon />
                    </IconButton>
                </Stack>
            </Grid>



        </Grid>
    );
}